import { BringzzButton, BringzzIcon, BringzzText } from '@bringzz/components';
import React from 'react';
import useUser from 'hooks/useUser';
import { USER_ROLES, SCAN_OPTIONS } from 'utils/constants';
import { useNavigation } from 'context/NavigationContext';

// ControlPanel Component (handles buttons like switching camera and navigation options)
const CameraControlPanel = ({ mode, selectedOption, setSelectedOption, onSwitchCamera, onImageSelected, isDisabled, hasMultipleCameras = true }) => {
    const { getUser } = useUser();
    const user = getUser();
    const { navigate } = useNavigation();

    // Add file input ref
    const fileInputRef = React.useRef(null);

    const handleGalleryClick = () => {
        if (isDisabled) return;
        fileInputRef.current?.click();
    };

    const handleFileChange = (event) => {
        if (isDisabled) return;
        const file = event.target.files?.[0];
        if (file && (file.type === 'image/jpeg' || file.type === 'image/png')) {
            onImageSelected(file);
        }
    };

    const handleCameraClick = () => {
        if (isDisabled) return;
        // Trigger photo capture in parent component
        onImageSelected('capture');
    };

    return (
        <div className="flex flex-col pt-10 w-full bg-black/80" style={{ paddingBottom: `calc(1.5rem + env(safe-area-inset-bottom, 0px))` }}>
            {/* Hidden file input */}
            <input
                type="file"
                ref={fileInputRef}
                className="hidden"
                accept="image/jpeg,image/png"
                onChange={handleFileChange}
                disabled={isDisabled}
            />
            {/* Option Switcher */}
            <div className="flex justify-evenly mb-10">
                {Object.values(SCAN_OPTIONS).map(option => (
                    <BringzzText
                        key={option}
                        tag="h4"
                        className={`text-white cursor-pointer ${selectedOption === option ? 'underline' : ''} ${isDisabled ? 'opacity-50' : ''}`}
                        onClick={() => !isDisabled && setSelectedOption(option)}
                    >
                        {option}
                    </BringzzText>
                ))}
            </div>
            {/* Camera Control */}
            <div className="flex items-center justify-around">
                <BringzzIcon
                    folder="LineIcons"
                    icon="IconGallery"
                    size="28"
                    className={`text-white cursor-pointer ${isDisabled ? 'opacity-50' : ''}`}
                    onClick={handleGalleryClick}
                />
                <div className={`relative border rounded-full p-1 cursor-pointer ${isDisabled ? 'opacity-50' : ''}`}>
                    <div
                        className="h-14 w-14 bg-white rounded-full"
                        onClick={handleCameraClick}
                    />
                    {isDisabled && (
                        <>
                            {/* Crossed lines */}
                            <div className="absolute top-0 left-1/2 h-full w-[2px] bg-black/20 -translate-x-1/2 animate-spin" />
                            <div className="absolute top-1/2 left-0 w-full h-[2px] bg-black/20 -translate-y-1/2 animate-spin" />
                        </>
                    )}
                </div>
                <BringzzIcon
                    folder="LineIcons"
                    icon="IconSwitch"
                    size="24"
                    className={`text-white ${!hasMultipleCameras || isDisabled ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
                    onClick={() => {
                        if (!isDisabled && hasMultipleCameras) {
                            onSwitchCamera();
                        }
                    }}
                />
            </div>
        </div>
    );
};

export default CameraControlPanel